import { ClientPortalAccessDenied } from './ClientPortalAccessDenied';
import { ClientPortalLoginPage } from './ClientPortalLoginPage';
import { usePortalAccess } from './PortalAccessContext';

/**
 * Punto único de gate por ruta del portal. Renderiza login/carga/denegado/
 * contenido AT the current path — nunca navega a otra URL para resolver
 * el estado de acceso, así que refresh, atrás/adelante y enlaces directos
 * siempre aterrizan en el lugar correcto.
 */
export function PortalGate({ granted }: { granted: JSX.Element }): JSX.Element {
  const { status } = usePortalAccess();

  if (status === 'unauthenticated') return <ClientPortalLoginPage />;
  if (status === 'checking') return <div className="portal-loading">Verificando acceso…</div>;
  if (status === 'denied') return <ClientPortalAccessDenied />;

  return granted;
}
